import { List as DefaultList } from './List';
import { withListState } from './List.state';

export const List = withListState(DefaultList);
